export const BRAND = Object.freeze({
  name: 'AgriLink',
  wordmark: 'AgriLink',
  iconPath: '/logo-icon.png',
  browserTitle: 'AgriLink',
  browserDescription: 'AgriLink Application',
  defaultCompanyName: 'AgriLink Dashboard',
  supportEmail: 'support@agrilink.dev',
  documentEmail: 'documenti@agrilink.dev',
  reportTitle: 'AgriLink report',
  reportFilenameStem: 'agrilink-report',
  reportDesigner: Object.freeze({
    en: 'AgriLink technical office',
    it: 'Ufficio tecnico AgriLink',
    es: 'oficina tecnica AgriLink',
  }),
});

export const getBrandReportDesigner = (locale = 'en') => (
  BRAND.reportDesigner[locale] || BRAND.reportDesigner.en
);
